import { useLingui } from "@lingui/react";
import MapInput from "../form-component/MapInput";
import { msg } from "@lingui/macro";
import { Alert, Box, Button, Tooltip, Typography } from "@mui/material";
import { useState } from "react";
import CloseIcon from '@mui/icons-material/Close';
import HomeIcon from '@mui/icons-material/Home';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { IconButton } from "@mui/material/";

const FirstPage = ({ getValues, control, geoControlRef, isMobile, CENTER, ZOOM, pageIndex, setPageIndex, resetForm }) => {
  const { _ } = useLingui();
  const [openAlert, setOpenAlert] = useState(false);

  const verifyAndNext = () => {
    const values = getValues();

    if (values.location && values.location !== ' ') {
      setOpenAlert(false);
      setPageIndex(pageIndex + 1);
    } else {
      setOpenAlert(true);
    }
  };

  return (
    <>
      <Box sx={{ padding: 4 }}>
        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginBottom: 2 }}>
          <Typography sx={{ fontWeight: 700 }}>{_(msg`Tap on the map to select crash location`)}</Typography>
          <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', gap: 2 }}>
            <Tooltip title={_(msg`Return to home`)}>
            <IconButton onClick={() => {
                resetForm();
                setPageIndex(pageIndex - 1);
                localStorage.removeItem('temporaryCoords');
              }} variant="contained" sx={{ display: 'flex', flex: 1 }}>
              <HomeIcon />
            </IconButton>
            </Tooltip>
            <Tooltip title={_(msg`Next`)}>
            <IconButton onClick={() => verifyAndNext()} variant="contained" sx={{ display: 'flex', flex: 1 }}>
              <NavigateNextIcon />
            </IconButton>
          </Tooltip>
          </Box>
        </Box>

      <MapInput
          name={'location'}
          control={control}
          label={_(msg`${'Location'}`)}
          center={CENTER}
          zoom={ZOOM}
          geoControlRef={geoControlRef}
          isMobile={isMobile} />
        

      </Box>
      {openAlert &&
      <Alert sx={{ width: '80%', marginLeft: '10%' }} action={
      <Button onClick={() => {setOpenAlert(false);}} color="inherit" size="small">
            <CloseIcon />
          </Button>
      } severity="error">
          <Typography>{_(msg`Please insert a location`)}</Typography>
        </Alert>
      }
      </>);


};
export default FirstPage;